import { ArrowRight, CheckCircle } from '@phosphor-icons/react';
import { useGetMe } from '@reelplicate/api-client/users';
import { useListWorkspaces } from '@reelplicate/api-client/workspaces';
import { Button } from '@reelplicate/ui';
import { Link as RouterLink } from 'react-router';

import { StatusIcon } from '@/features/auth/status-icon';

import { OnboardingActions, OnboardingCard, OnboardingHeader } from './onboarding-card';

/**
 * Figma "Onboarding — 9 · All set" (128:1637): a success Status Icon, the
 * welcome, a bg/subtle summary (radius 16, 20px sides, rows with
 * border/subtle rules) and "Go to dashboard". The summary lists what the
 * account holds today - plan, competitors, platforms and invites join it
 * once those steps are saved.
 */
export function AllSetPage() {
  const { data: me } = useGetMe();
  const { data: workspaces } = useListWorkspaces();
  const firstName = me?.name?.split(' ')[0];
  const workspace = workspaces?.[0]?.name;
  const summary = [
    ['Workspace', workspace],
    ['Account', me?.email],
  ].filter((row): row is [string, string] => Boolean(row[1]));

  return (
    <OnboardingCard loose onSubmit={(event) => event.preventDefault()}>
      <OnboardingHeader
        loose
        visual={<StatusIcon icon={CheckCircle} tone="success" />}
        title={firstName ? `You’re all set, ${firstName}` : 'You’re all set'}
        subtitle={`${workspace ?? 'Your workspace'} is ready. Your first drafts will be waiting for review.`}
      />
      {summary.length > 0 && (
        <dl className="bg-bg-subtle divide-border-subtle text-body-md divide-y rounded-2xl px-5 py-2">
          {summary.map(([term, value]) => (
            <div key={term} className="flex items-start justify-between gap-4 py-3">
              <dt className="text-text-secondary">{term}</dt>
              <dd className="text-body-md-strong text-right">{value}</dd>
            </div>
          ))}
        </dl>
      )}
      <OnboardingActions>
        <Button asChild size="lg" trailingIcon={ArrowRight}>
          <RouterLink to="/">Go to dashboard</RouterLink>
        </Button>
      </OnboardingActions>
    </OnboardingCard>
  );
}
